import { getRoutePathToTCI } from "@okf/ootils";

// Static link to the SM Integrations page. The `contentType` arg here is
// repurposed as the row's linkedIntegration provider name (via the
// contentTypePath: "linkedIntegration" mapping in cellData); when empty we
// return undefined so the cell renders blank for rows that aren't linked.
const getRoutePathToIntegrations = ({ contentType }) => {
  if (!contentType) return undefined;
  return "/integrations";
};

const TableLink_routePathGeneratorLookup = {
  getRoutePathToTCI,
  getRoutePathToIntegrations,
};

export const resolveRoutePathFromGenerator = ({ routePathGenerator, tableRowData, SELF_MANAGED_BASE_CONFIGS }) => {
  const { fn, contentTypePath } = routePathGenerator;
  const generatorFn = TableLink_routePathGeneratorLookup[fn];
  if (!generatorFn) return undefined;
  return generatorFn({
    contentType: tableRowData[contentTypePath],
    SELF_MANAGED_BASE_CONFIGS,
  });
};

export { TableLink_routePathGeneratorLookup };
